import { render, staticRenderFns } from "./press.vue?vue&type=template&id=7c7a2704&scoped=true"
import script from "./press.vue?vue&type=script&lang=js"
export * from "./press.vue?vue&type=script&lang=js"
import style0 from "./press.vue?vue&type=style&index=0&id=7c7a2704&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7a2704",
  null
  
)

export default component.exports